import { useFetchGet } from "hooks/fetch/useFetchGet";
import { makeQueryString } from "core/makeQueryString";
import { isEmpty } from "lodash";
import { useEffect, useMemo, useState } from "react";

export function useGetMachineComponents(machine) {
  const [scalarConfigIds, setScalarConfigIds] = useState();

  useEffect(() => {
    if (machine) {
      setScalarConfigIds(machine?.scalar_configurations.join(",") ?? []);
    } else {
      setScalarConfigIds();
    }
  }, [machine]);

  const url = useMemo(
    () =>
      `components${makeQueryString({
        scalar_configuration_id__in: scalarConfigIds
      })}`,
    [scalarConfigIds]
  );

  const {
    loading: componentsLoading,
    error: componentsError,
    response
  } = useFetchGet(url, isEmpty(scalarConfigIds));

  return {
    componentsLoading,
    componentsError,
    components: response?.results,
    count: response?.count
  };
}
